import React from 'react';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  return (
    <main className="pt-20 md:pt-24 bg-[#0b0b0b]">
      <ContactForm />
    </main>
  );
}
